// import { configureStore, Tuple } from '@reduxjs/toolkit'
// import rootReducer from './rootReducers';
// import createSagaMiddleware from 'redux-saga';
// import { rootSaga } from './rootSaga';
// import logger from 'redux-logger';
// import { createBrowserHistory } from "history";
// const sagaMiddleware = createSagaMiddleware();
// export const history = createBrowserHistory();
// const store = configureStore({
//     reducer: rootReducer(history), middleware: () => new Tuple(sagaMiddleware, logger)
// });
// sagaMiddleware.run(rootSaga);
// export default store;


import { configureStore, Tuple } from '@reduxjs/toolkit';
import rootReducer from './rootReducers';
import createSagaMiddleware from 'redux-saga';
import { rootSaga } from './rootSaga';
import logger from 'redux-logger';
const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
    reducer: rootReducer(),
    middleware: () => new Tuple(sagaMiddleware),
});
sagaMiddleware.run(rootSaga);
export default store;